// ======================================================================
// File Name       : ContentDrillEditAdvanced
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, Col, FormControl } from 'react-bootstrap';
import FileUpload from '../../components/FileUpload';
import FormControlValidate from '../../components/FormControlValidate';
import { CONTENT_DRILL_OBJECT } from '../../constants/ContentConstant';
import { VALIDATE_TYPE } from '../../constants/index';
import * as MessageTemplate from '../../constants/MessageTemplate';

class ContentDrillEditAdvanced extends React.Component {
  constructor(props) {
    super(props);
    this.validation = this.validation.bind(this);
  }
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }
  render() {
    const {
      handleChange,
      openOrCloseAdvanceSettings,
      buttonText,
      isClosed,
      limitTimeAdaptedTarget,
      limitTimeOverAction,
      limitTimeCountForm,
      markRule,
      sankakuJudgeUseSet,
      attentionRelateSet,
      attentionHtmlUse,
      handleFileChange,
      attentionHtmlFileName,
      remark,
      perfectPoint,
      sankakuMarkSet,
      drillLimitTime,
      attentionContent,
    } = this.props;
    this.refsToValidate = [];
    const fullMarkRequired = parseInt(markRule, 10) === 1 || parseInt(markRule, 10) === 2;
    return (
      <div className="col-sm-12">
        <Form.Group className="form-info margin-top-20">
          <Col sm={12} as={Form.Label} className="padding-left-5">
            <a role="presentation" className={buttonText} onClick={openOrCloseAdvanceSettings}>
              詳細設定
              </a>
          </Col>
        </Form.Group>
        {!isClosed &&
        <div>
          <Form.Group className="form-info">
            <Col sm={2} as={Form.Label} className="padding-right-clear" >
              制限時間
            </Col>
            <Col sm={2} as={Form.Label} className="padding-left-right-clear">
              対象
            </Col>
            <Col sm={7}>
              <Col sm={4} className="padding-left-clear">
                <Form.Check
                  type='radio'
                  inline
                  name="timeLimitNotUsed"
                  id="timeLimitNotUsed"
                  value={CONTENT_DRILL_OBJECT.DO_NOT_USE}
                  checked={limitTimeAdaptedTarget === CONTENT_DRILL_OBJECT.DO_NOT_USE}
                  onChange={handleChange}
                  label='利用しない'></Form.Check>
              </Col>
              <Col sm={4}>
                <Form.Check
                  type='radio'
                  inline
                  name="timeLimitDrill"
                  id="timeLimitDrill"
                  value={CONTENT_DRILL_OBJECT.DRILL_PRIORITY}
                  checked={limitTimeAdaptedTarget === CONTENT_DRILL_OBJECT.DRILL_PRIORITY}
                  onChange={handleChange}
                  label='ドリル優先'></Form.Check>
              </Col>
              <Col sm={4}>
                <Form.Check
                  type='radio'
                  inline
                  name="timeLimitQuestion"
                  id="timeLimitQuestion"
                  value={CONTENT_DRILL_OBJECT.QUESTION_PRIORITY}
                  checked={limitTimeAdaptedTarget === CONTENT_DRILL_OBJECT.QUESTION_PRIORITY}
                  onChange={handleChange}
                  label='問題優先'></Form.Check>
              </Col>
            </Col>
          </Form.Group>
          {limitTimeAdaptedTarget !== CONTENT_DRILL_OBJECT.DO_NOT_USE &&
          <div>
            {limitTimeAdaptedTarget === CONTENT_DRILL_OBJECT.DRILL_PRIORITY && <Form.Group className="form-info">
              <Col sm={2} className="padding-right-clear" />
              <Col sm={2} as={Form.Label} className="padding-left-right-clear">
                      ドリル制限時間
                    </Col>
              <Col sm={7}>
                <FormControlValidate
                  type="text"
                  maxLength="4"
                  name="drillLimitTime"
                  value={drillLimitTime}
                  onChange={handleChange}
                  validateType={VALIDATE_TYPE.NUMERIC}
                  messageError={MessageTemplate.MSG_NUMERIC_INVALID}
                  messageSuccess={MessageTemplate.MSG_NUMERIC_VALID}
                  label="ドリル制限時間"
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                />
              </Col>
              <Col sm={1} className="text-left margin-top-10 padding-left-15">
                <span> 秒</span>
              </Col>
                </Form.Group> }
            <Form.Group className="form-info">
              <Col sm={2} className="padding-right-clear" />
              <Col sm={2} as={Form.Label} className="padding-left-right-clear">
                      タイマー超過時のアクション
                    </Col>
              <Col sm={7}>
                <Form.Select  
                  as="select"
                  name="limitTimeOverAction"
                  value={limitTimeOverAction}
                  onChange={handleChange}
                >
                  <option value={0}>何もしない</option>
                  <option value={1}>強制終了</option>
                </Form.Select>
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col sm={2} className="padding-right-clear" />
              <Col sm={2} as={Form.Label} className="padding-left-right-clear">
                      カウント方法
                    </Col>
              <Col sm={7}>
                <Form.Select
                  as="select"
                  name="limitTimeCountForm"
                  value={limitTimeCountForm}
                  onChange={handleChange}
                >
                  <option value={1}>カウントアップ</option>
                  <option value={2}>カウントダウン</option>
                  <option value={3}>カウントアップバー</option>
                  <option value={4}>カウントダウンバー</option>
                </Form.Select>
              </Col>
            </Form.Group>
          </div>}
          <Form.Group className="form-info">
            <Col sm={4} as={Form.Label}>
                  配点ルール
                </Col>
            <Col sm={7}>
              <Form.Select
                as="select"
                name="markRule"
                value={markRule}
                onChange={handleChange}
              >
                <option value={0}>絶対配点</option>
                <option value={1}>点数按分</option>
                <option value={2}>加重平均配点</option>
                <option value={3}>グループ配点</option>
              </Form.Select>
            </Col>
          </Form.Group>
          {(parseInt(markRule, 10) === 1 || parseInt(markRule, 10) === 2) && // #6582
          <Form.Group className="form-info">
            <Col sm={2} className="padding-right-clear" />
            <Col sm={2} as={Form.Label} className="padding-left-right-clear">
                満点{fullMarkRequired && <span className="required">&nbsp;(※)</span>}
            </Col>
            <Col sm={7}>
              <FormControlValidate
                type="text"
                maxLength="4"
                name="perfectPoint"
                value={perfectPoint || ''}
                onChange={handleChange}
                validateType={VALIDATE_TYPE.NUMERIC}
                messageError={MessageTemplate.MSG_NUMERIC_INVALID}
                messageSuccess={MessageTemplate.MSG_NUMERIC_VALID}
                label="満点"
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                required={fullMarkRequired}
              />
            </Col>
            <Col sm={1} className="text-left margin-top-10 padding-left-15">
              点
            </Col>
          </Form.Group>}
          <Form.Group className="form-info">
            <Col sm={4} as={Form.Label}>
              △判定を使用する
            </Col>
            <Col sm={7}>
              <Form.Check
                type='checkbox'
                className="padding-left-right-clear padding-top-10"
                name="sankakuJudgeUseSet"
                id="sankakuJudgeUseSet"
                checked={sankakuJudgeUseSet}
                onChange={handleChange} />
            </Col>
          </Form.Group>
          {sankakuJudgeUseSet ?
            <Form.Group className="form-info">
              <Col sm={2} className="padding-right-clear" />
              <Col sm={2} as={Form.Label} className="padding-left-right-clear">
                部分点付与
              </Col>
              <Col sm={7}>
                <FormControlValidate
                  type="text"
                  maxLength="4"
                  label="部分点付与"
                  name="sankakuMarkSet"
                  value={sankakuMarkSet}
                  onChange={handleChange}
                  validateType={VALIDATE_TYPE.NUMERIC}
                  required={sankakuJudgeUseSet}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                />{' '}
              </Col>
              <Col sm={1} className="text-left margin-top-10 padding-left-15">
                %
              </Col>
            </Form.Group> : null}
          <Form.Group className="form-info">
            <Col sm={4} as={Form.Label}>
              注意点を使用する
            </Col>
            <Col sm={7}>
              <Form.Check
                type='checkbox'
                className="padding-left-right-clear padding-top-10"
                name="attentionRelateSet"
                id="attentionRelateSet"
                checked={attentionRelateSet}
                onChange={handleChange} />
            </Col>
          </Form.Group>
          {attentionRelateSet ?
            <div>
              <Form.Group className="form-info">
                <Col sm={2} className="padding-right-clear" />
                <Col sm={2} as={Form.Label} className="padding-left-right-clear">
                      内容
                    </Col>
                <Col sm={7}>
                  <Col sm={6} className="padding-left-right-clear">
                    <Form.Check
                      type='radio'
                      inline
                      name="notUseHTML"
                      id="notUseHTML"
                      value={!attentionHtmlUse}
                      checked={!attentionHtmlUse}
                      onChange={handleChange}
                      label='HTMLを使用しない'></Form.Check>
                  </Col>
                  <Col sm={6} className="margin-bottom-10">
                    <Form.Check
                      type='radio'
                      inline
                      name="attentionHtmlUse"
                      id="attentionHtmlUse"
                      value={attentionHtmlUse}
                      checked={attentionHtmlUse}
                      onChange={handleChange}
                      label='HTMLを使用する'></Form.Check>
                  </Col>
                  {attentionHtmlUse &&
                  <Col sm={12} className="padding-left-right-clear">
                    <FileUpload
                      labelName="ファイル選択"
                      id="contentDrillFileUpload"
                      onChange={handleFileChange}
                      attentionHtmlFileName={attentionHtmlFileName}
                      accept=".zip"
                    />
                  </Col>}
                  {!attentionHtmlUse &&
                  <Col sm={12} className="padding-left-right-clear padding-bottom-10">
                    <FormControlValidate
                      id="contentDrillRegisterRemark"
                      as="textarea"
                      className="textArea"
                      name="attentionContent"
                      maxLength="30000"
                      onChange={handleChange}
                      value={attentionContent}
                      label="内容"
                      ref={(ref) => {
                        if (ref) {
                          this.refsToValidate.push(ref);
                        }
                      }}
                      required
                    />
                  </Col>}
                  {attentionHtmlUse &&
                    <Col sm={12} className="padding-left-right-clear margin-top-10">
                      <FormControlValidate
                        label="ファイル名"
                        validateType={VALIDATE_TYPE.LABEL}
                        value={attentionHtmlFileName && `ファイル名：${attentionHtmlFileName}`}
                        ref={(ref) => {
                          if (ref) {
                            this.refsToValidate.push(ref);
                          }
                        }}
                        required
                      />
                    </Col>}
                </Col>
              </Form.Group>
            </div> : null}
        </div>}
      </div>
    );
  }
}
export default ContentDrillEditAdvanced;
